module.exports = __webpack_public_path__ + "static/img/ci.f0b0cd5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lotte-group/ci.png
// module id = /l/U
// module chunks = 0